import { render, staticRenderFns } from "./ExternalParticipant.vue?vue&type=template&id=336cab06&"
import script from "./ExternalParticipant.vue?vue&type=script&lang=js&"
export * from "./ExternalParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336cab06')) {
      api.createRecord('336cab06', component.options)
    } else {
      api.reload('336cab06', component.options)
    }
    module.hot.accept("./ExternalParticipant.vue?vue&type=template&id=336cab06&", function () {
      api.rerender('336cab06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Recipients/ExternalParticipant.vue"
export default component.exports